// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-tabs{
    display: flex;
 
    border-bottom: none !important;
}
.nav-link{
    color: black !important;
}

.roadmap-tab{
    width: 90%;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active{
    border-radius: 5px;
    background-color:rgba(43, 167, 105, 1) !important; 
    color: white !important;
    box-shadow: none !important;
}
.nav-tabs .nav-link{
     border-radius: 5px;
     box-shadow: 2px 2px 10px rgba(128, 128, 128, 0.321) !important;
}
@media (max-width:992px) {
    
.roadmap-tab{
    width: 100%;
}
}`, "",{"version":3,"sources":["webpack://./src/styles/roadmap.css"],"names":[],"mappings":"AAAA;IACI,aAAa;;IAEb,8BAA8B;AAClC;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;KACK,kBAAkB;KAClB,8DAA8D;AACnE;AACA;;AAEA;IACI,WAAW;AACf;AACA","sourcesContent":[".nav-tabs{\n    display: flex;\n \n    border-bottom: none !important;\n}\n.nav-link{\n    color: black !important;\n}\n\n.roadmap-tab{\n    width: 90%;\n}\n\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active{\n    border-radius: 5px;\n    background-color:rgba(43, 167, 105, 1) !important; \n    color: white !important;\n    box-shadow: none !important;\n}\n.nav-tabs .nav-link{\n     border-radius: 5px;\n     box-shadow: 2px 2px 10px rgba(128, 128, 128, 0.321) !important;\n}\n@media (max-width:992px) {\n    \n.roadmap-tab{\n    width: 100%;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
